/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_ReleaseInputs */

const en_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next release:`)
};

const es_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima liberación:`)
};

const fr_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prochain déblocage :`)
};

const de_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Freigabe:`)
};

const ja_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次回のリリース:`)
};

const zh_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下次释放：`)
};

const ar_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإفراج القادم:`)
};

const id_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis berikutnya:`)
};

const it_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo sblocco:`)
};

const ru_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующее освобождение:`)
};

const pt_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima liberação:`)
};

const ko_next_release = /** @type {(inputs: Next_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 지급 예정일:`)
};

/**
* | output |
* | --- |
* | "Next release:" |
*
* @param {Next_ReleaseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const next_release = /** @type {((inputs?: Next_ReleaseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_ReleaseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_next_release(inputs)
	if (locale === "es") return es_next_release(inputs)
	if (locale === "fr") return fr_next_release(inputs)
	if (locale === "de") return de_next_release(inputs)
	if (locale === "ja") return ja_next_release(inputs)
	if (locale === "zh") return zh_next_release(inputs)
	if (locale === "ar") return ar_next_release(inputs)
	if (locale === "id") return id_next_release(inputs)
	if (locale === "it") return it_next_release(inputs)
	if (locale === "ru") return ru_next_release(inputs)
	if (locale === "pt") return pt_next_release(inputs)
	return ko_next_release(inputs)
});